import React, { useState } from "react";

import axios from "axios";

export default function BesoinVAE() {
	const [cd, setCd] = useState();
	const [handicap, setHandicap] = useState();
	const [temps, setTemps] = useState();

	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const userID = urlParams.get("id");
	const userName = urlParams.get("name");

	const [etude, setEtude] = useState("");
	const [profession, setProfession] = useState();
	const [secteur, setSecteur] = useState();
	const [autres, setAutres] = useState();
	const [objectifs, setObjectifs] = useState();

	const [error, setError] = useState("");

	const sendForm = async e => {
		e.preventDefault();

		var contrat;
		var typeTemps;
		var resHandicap;

		if (cd === 0) {
			contrat = "CDI";
		}

		if (cd === 1) {
			contrat = "CDD";
		}

		if (temps === 1) {
			typeTemps = "Partiel";
		}

		if (temps === 0) {
			typeTemps = "Complet";
		}

		if (handicap === 1) {
			resHandicap = "Non";
		}

		if (handicap === 0) {
			resHandicap = "Oui";
		}

		if (
			cd === undefined ||
			handicap === undefined ||
			temps === undefined ||
			!etude ||
			!profession ||
			!secteur ||
			!autres ||
			!objectifs
		) {
			return setError("Veuillez remplir tous les champs");
		}

		try {
			axios
				.post("https://global-academie.herokuapp.com/avis/vae", {
					userID,
					userName,
					contrat,
					typeTemps,
					resHandicap,
					etude,
					profession,
					secteur,
					autres,
					objectifs,
				})
				.then(res => {
					console.log(res);
				});
		} catch (error) {
			console.log(error);
		}
	};

	if (error) {
		setTimeout(() => {
			setError("");
		}, 3000);
	}

	return (
		<div className="flex min-h-screen w-full flex-col items-center justify-center">
			<form
				onSubmit={sendForm}
				className="my-16 flex w-full flex-col items-center justify-center space-y-7 md:w-[60%]"
			>
				<h2 className=" flex w-full items-center justify-between text-3xl font-bold text-indigo-500">
					Questionnaire de besoin VAE
				</h2>
				<hr className="my-4 h-[3px] w-[100px] self-start border-none bg-indigo-200" />
				<div className="w-full">
					<label
						className="pl-1 font-medium dark:text-indigo-200"
						htmlFor="niveau"
					>
						Niveau d'étude
					</label>
					<select
						value={etude}
						onChange={e => setEtude(e.target.value)}
						name="niveau"
						id="niveau"
						className="mt-1 w-full rounded-md border border-gray-400/50 bg-white p-2 px-3 shadow-md outline-none dark:bg-gray-700 dark:text-white"
					>
						<option value="" disabled>
							Niveau d'étude
						</option>
						<option value="Niveau 1">
							Niveau 1 (CQP sans niveau de qualification)
						</option>
						<option value="Niveau 2">Niveau 2 (BEP, CAP)</option>
						<option value="Niveau 3">
							Niveau 3 (Bac pro, BT, BP, BM...)
						</option>
						<option value="Niveau 4">
							Niveau 4 (BTS, DUT, école de formation sanitaire et
							sociale)
						</option>
						<option value="Niveau 5">Niveau 5 (Licence)</option>
						<option value="Niveau 6">
							Niveau 6 (Master, diplôme d'ingénieur)
						</option>
						<option value="Niveau 7">Niveau 7 (Doctorat)</option>
					</select>
				</div>
				<div className="w-full">
					<label
						className="pl-1 font-medium dark:text-indigo-200"
						htmlFor="profession"
					>
						Profession
					</label>
					<input
						value={profession}
						onChange={e => setProfession(e.target.value)}
						name="profession"
						id="profession"
						placeholder="Profession"
						className="mt-1 w-full rounded-md border border-gray-400/50 bg-white p-2 px-3 shadow-md outline-none dark:bg-gray-700 dark:text-white"
					/>
				</div>
				<div className="w-full">
					<label
						className="pl-1 font-medium dark:text-indigo-200"
						htmlFor="secteur"
					>
						Secteur d'activité
					</label>
					<input
						value={secteur}
						onChange={e => setSecteur(e.target.value)}
						name="secteur"
						id="secteur"
						placeholder="Secteur d'activité"
						className="mt-1 w-full rounded-md border border-gray-400/50 bg-white p-2 px-3 shadow-md outline-none dark:bg-gray-700 dark:text-white"
					/>
				</div>
				<div className="w-full">
					<label
						className="pl-1 font-medium dark:text-indigo-200"
						htmlFor="contrat"
					>
						Nature du contrat de travail
					</label>
					<div className="mt-3 flex w-full items-center justify-between">
						<button
							type="button"
							onClick={() => setCd(0)}
							className={
								cd === 0
									? "w-[200px] rounded-md border-2 border-transparent bg-indigo-500 p-2 font-medium text-white transition-all duration-200"
									: "w-[200px] rounded-md border-2 border-indigo-500 p-2 font-medium transition-all duration-200 hover:border-transparent hover:bg-indigo-500 hover:text-white"
							}
						>
							CDI
						</button>
						<button
							type="button"
							onClick={() => setCd(1)}
							className={
								cd === 1
									? "w-[200px] rounded-md border-2 border-transparent bg-indigo-500 p-2 font-medium text-white transition-all duration-200"
									: "w-[200px] rounded-md border-2 border-indigo-500 p-2 font-medium transition-all duration-200 hover:border-transparent hover:bg-indigo-500 hover:text-white"
							}
						>
							CDD
						</button>
						à
						<button
							type="button"
							onClick={() => setTemps(0)}
							className={
								temps === 0
									? "w-[200px] rounded-md border-2 border-transparent bg-indigo-500 p-2 font-medium text-white transition-all duration-200"
									: "w-[200px] rounded-md border-2 border-indigo-500 p-2 font-medium transition-all duration-200 hover:border-transparent hover:bg-indigo-500 hover:text-white"
							}
						>
							Temps complet
						</button>
						<button
							type="button"
							onClick={() => setTemps(1)}
							className={
								temps === 1
									? "w-[200px] rounded-md border-2 border-transparent bg-indigo-500 p-2 font-medium text-white transition-all duration-200"
									: "w-[200px] rounded-md border-2 border-indigo-500 p-2 font-medium transition-all duration-200 hover:border-transparent hover:bg-indigo-500 hover:text-white"
							}
						>
							Temps partiel
						</button>
					</div>
				</div>
				<div className="w-full">
					<label
						className="pl-1 font-medium dark:text-indigo-200"
						htmlFor="autresContrats"
					>
						Autres contrats (demandeur d'emploi, bénévole, sans
						contrat de travail)
					</label>
					<input
						value={autres}
						onChange={e => setAutres(e.target.value)}
						name="autresContrats"
						id="autresContrats"
						placeholder="Autres contrats"
						className="mt-1 w-full rounded-md border border-gray-400/50 bg-white p-2 px-3 shadow-md outline-none dark:bg-gray-700 dark:text-white"
					/>
				</div>
				<div className="w-full">
					<label
						className="font-medium dark:text-indigo-200"
						htmlFor="objectifsBilan"
					>
						Objectifs poursuivis lors du bilan (Projet professionnel
						interne/externe à l'entreprise, plan social,
						repositionnement après licenciement, reprise d'emploi)
					</label>
					<input
						value={objectifs}
						onChange={e => setObjectifs(e.target.value)}
						name="objectifsBilan"
						id="objectifsBilan"
						placeholder="Objectifs poursuivis lors du bilan"
						className="mt-1 w-full rounded-md border border-gray-400/50 bg-white p-2 px-3 shadow-md outline-none dark:bg-gray-700 dark:text-white"
					/>
				</div>
				<div className="w-full">
					<label
						className="pl-1 font-medium dark:text-indigo-200"
						htmlFor="contrat"
					>
						Avez-vous un handicap nécessitant un aménagement
						spécifique du bilan de compétences?
					</label>
					<div className="mt-3 flex w-full items-center justify-start space-x-6">
						<button
							type="button"
							onClick={() => setHandicap(0)}
							className={
								handicap === 0
									? "w-[200px] rounded-md border-2 border-transparent bg-indigo-500 p-2 font-medium text-white transition-all duration-200"
									: "w-[200px] rounded-md border-2 border-indigo-500 p-2 font-medium transition-all duration-200 hover:border-transparent hover:bg-indigo-500 hover:text-white"
							}
						>
							Oui
						</button>
						<button
							type="button"
							onClick={() => setHandicap(1)}
							className={
								handicap === 1
									? "w-[200px] rounded-md border-2 border-transparent bg-indigo-500 p-2 font-medium text-white transition-all duration-200"
									: "w-[200px] rounded-md border-2 border-indigo-500 p-2 font-medium transition-all duration-200 hover:border-transparent hover:bg-indigo-500 hover:text-white"
							}
						>
							Non
						</button>
					</div>
				</div>
				{error && (
					<span className="w-full rounded bg-red-100 p-3 font-medium text-red-500">
						{error}
					</span>
				)}
				<button
					type="submit"
					className="w-full rounded-md border-2 border-transparent bg-indigo-500 p-3 font-medium text-white transition-all duration-200 hover:border-indigo-500 hover:bg-transparent hover:text-indigo-500"
				>
					Envoyer
				</button>
			</form>
		</div>
	);
}
